import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";
import { TICKET_FOLDER } from "@constant";
import { classNames, validateUrl } from "@utilscommon";
import LocaleStrings from "@language";

const Footer = (props) => {
  const location = useLocation();

  let { eventSettingsData } = props;

  const handleRedirect = (page) => {
    let param = location.search;
    let field =
      page === "terms-conditions"
        ? eventSettingsData?.data?.termsandconditions
        : eventSettingsData?.data?.privacy;

    if (validateUrl(field)) {
      window.open(`${field}`, "_blank");
    } else {
      window.open(`${TICKET_FOLDER}/${page}${param}`, "_blank");
    }
  };

  return (
    <header
      id="MAIN_FOOTER"
      className={classNames("main-footer py-6 px-4 lg:px-6 xl:px-0")}
    >
      <div className="mx-auto max-w-4xl">
        <div className="custom-item-center space-x-3">
          <div
            className="FOOTER_PRIVACY_POLICY_SECTION PRIVACY_POLICY_SECTION custom-text-theme-md-medium flex items-center cursor-pointer hover:underline break-all"
            onClick={() => handleRedirect("privacy-policy")}
          >
            <div
              className="LIST_ITEM_ICON relative flex h-5 w-5 flex-shrink-0 items-center justify-center"
              aria-hidden="true"
            >
              <div className="h-2 w-2 rounded-full bg-themeLight" />
            </div>
            <span> {LocaleStrings.KPrivacyPolicy}</span>
          </div>
          <div
            className="FOOTER_TERMS_CONDITIONS_SECTION TERMS_CONDITIONS_SECTION custom-text-theme-md-medium flex items-center cursor-pointer hover:underline break-all"
            onClick={() => handleRedirect("terms-conditions")}
          >
            <div
              className="LIST_ITEM_ICON relative flex h-5 w-5 flex-shrink-0 items-center justify-center"
              aria-hidden="true"
            >
              <div className="h-2 w-2 rounded-full bg-themeLight" />
            </div>
            <span>{LocaleStrings.kTermsAndConditions}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    eventSettingsData: state.eventSettingsData,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
